import { render } from "./FunctionalOTPAgree.vue?vue&type=template&id=71a0aee8&scoped=true"
import script from "./FunctionalOTPAgree.vue?vue&type=script&lang=js"
export * from "./FunctionalOTPAgree.vue?vue&type=script&lang=js"

import "./FunctionalOTPAgree.vue?vue&type=style&index=0&id=71a0aee8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a0aee8"]])

export default __exports__